import React, { PureComponent } from "react";
import cx from "classnames";
//
import Alert from "./Alert";
import Autocomplete from "./Autocomplete";
import Map from "./Map";

// TODO: Eventually integrate with the geolocation API
// https://developer.mozilla.org/en-US/docs/Web/API/Geolocation_API
const geo = false;
// const geo = navigator.geolocation;

export default class LocationPicker extends PureComponent {
  state = {
    error: null,
    mapVisible: false,
  };

  _onChange = (ev) => this.setState({ query: ev.target.value });

  _handleInput = (query) => {
    this.setState({ mapVisible: false });

    if (query.length > 3) {
      this.props.onInput(query);
    }
  };

  _toggleMap = (ev) => this.setState({ mapVisible: !this.state.mapVisible });

  _onMapClick = (ev) => ev.stop();

  render() {
    const { placeholder, location, places, className, onSelect } = this.props;
    const { error, mapVisible } = this.state;

    const items = places.map(({ placeId, description }) => ({
      id: placeId,
      name: description,
    }));

    return (
      <div className={className}>
        <Autocomplete
          onInput={this._handleInput}
          onSelect={onSelect}
          items={items}
          placeholder={placeholder}
        />
        {location !== null && (
          <address className="u-m">
            <strong>{location.name}</strong>
            <br />
            <small className="u-muted">{location.address}</small>
            <br />
            <a className="u-small u-link" onClick={this._toggleMap}>{`${
              mapVisible ? "Hide" : "Show"
            } map`}</a>
          </address>
        )}
        {mapVisible && this.renderMap()}
        {error !== null && <Alert error text={error} className="u-mt" />}
      </div>
    );
  }

  renderMap() {
    const { location, city } = this.props;

    const mapOptions = {
      zoom: 15,
      disableDefaultUI: true,
      zoomControl: true,
      draggable: false,
    };

    const markers = [];

    if (location) {
      markers.push({
        key: location.id,
        position: { lat: location.lat, lng: location.lng },
      });
    }

    return (
      <Map
        lat={city.lat}
        lng={city.lng}
        markers={markers}
        options={mapOptions}
        onClick={this._onMapClick}
      />
    );
  }

  // _locate = ev => {
  //   this.props.onLocate();

  //   // https://developer.mozilla.org/en-US/docs/Web/API/Position
  //   // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
  //   geo.getCurrentPosition(this.props.onPosition, this.onPositionError);
  // };

  // onPositionError(error) {
  //   this.setState({ error: error.message });
  //   this.props.onPositionError(error);
  // }
}
